import { useQuery } from "@tanstack/react-query";
import React from "react";
import {
  CLIENT_NUTRITION_ENTRIES_QUERY_KEY,
  CLIENT_NUTRITION_TARGETS_QUERY_KEY,
} from "../../../../components/client-nutrition-targets/ClientNutritionCard";
import { useClient } from "../../../../hooks/useClient";
import NutritionTargetsService from "../../../../services/NutritionTargetsService";
import ClientNutritionScreen from "../../../../components/screen/ClientNutritionScreen";
import NutritionEntriesService from "../../../../services/NutritionEntriesService";
import dayjs from "dayjs";

export const CoachClientNutritionRoute = () => {
  const { id: clientId, username } = useClient();

  const { data: nutritionTargets, isLoading: isLoadingTargets } = useQuery({
    queryKey: [CLIENT_NUTRITION_TARGETS_QUERY_KEY, { username }],
    queryFn: () => NutritionTargetsService.getNutritionTargets(username),
  });

  const { data: nutritionEntries, isLoading: isLoadingEntries } = useQuery({
    queryKey: [CLIENT_NUTRITION_ENTRIES_QUERY_KEY, { username }],
    queryFn: () => NutritionEntriesService.getNutritionEntries(username),
  });

  const filteredNutritionEntries = nutritionEntries?.filter(
    (entry) => entry.date && entry.date.isSame(dayjs(), "day"),
  );

  return (
    <ClientNutritionScreen
      loading={isLoadingTargets || isLoadingEntries}
      autoNutritionMacroTarget={nutritionTargets}
      autoNutritionLastSync={filteredNutritionEntries?.[0]?.lastModified?.format(
        "h:mm A, MMM DD, YYYY",
      )}
    />
  );
};
